import UserDashboard from './UserDashboard';
import SystemAdminDashboard from './SystemAdminDashboard';
import CustomerUserDashboard from './CustomerUserDashboard';
import LocationCustomerDashboard from './LocationCustomerDashboard';
import LocationCustomerDashboard2 from './LocationCustomerDashboard2';
import LocationCustomerDashboard3 from './LocationCustomerDashboard3';

export {
	UserDashboard,
	SystemAdminDashboard,
	CustomerUserDashboard,
	LocationCustomerDashboard,
	LocationCustomerDashboard2,
	LocationCustomerDashboard3
}